import { UserBio } from '../../../types/users'

export const updateUserDetails = (users: UserBio[], newDetails: UserBio): UserBio[] =>
  users.map((user) => (user.user_id === newDetails.user_id ? newDetails : user))
